import React from 'react';
import { DropdownOption } from './DropdownOption';
import SearchableDropdown from './SearchableDropdown';

interface YearFilterProps {
  selectedYear: number | null;
  onYearChange: (year: number) => void;
}

export const SearchableYearFilterDropdown = React.forwardRef<HTMLElement, YearFilterProps>((props, ref) => {
  const { selectedYear, onYearChange } = props;

  const years: DropdownOption[] = Array.from({ length: 5 }, (_, i) => ({
    text: (new Date().getFullYear() - i).toString(),
    value: (new Date().getFullYear() - i).toString()
  }));

  const defaultItem = { text: "Select Year", value: "" };

  return (
    <SearchableDropdown
      label="Year"
      name="year"
      options={years}
      value={
        selectedYear !== null 
        ? years.find((option) => option.value === selectedYear?.toString()) 
        : defaultItem }
      onChange={(e) => onYearChange(e.target.value.value as number)}
      defaultItem={defaultItem}
    />
  );
});

SearchableYearFilterDropdown.displayName = 'YearFilter';

export default SearchableYearFilterDropdown;
